var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-button"},[_c('v-btn',{attrs:{"fab":"","dark":"","color":"#3047ec"},on:{"click":_vm.openSupportModal}},[_c('v-icon',{attrs:{"dark":"","medium":""}},[_vm._v("live_help")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }